export default __webpack_public_path__ + "static/media/after-life.9e93940c.svg";